module.exports = __webpack_public_path__ + "img/andromeda.f869bd2b.svg";